import _ from 'lodash'
import { MutationTree } from 'vuex'
import { FinalReviewSheet, FinalReviewSheetsState } from '@/store/lessons/finalReviewSheet/types'

const mutations: MutationTree<FinalReviewSheetsState> = {
  gotFinalReviewSheet: (state, finalReviewSheet: FinalReviewSheet) => {
    state.finalReviewSheets = _.uniqBy([
      finalReviewSheet,
      ...state.finalReviewSheets,
    ], 'lessonId')
  },
}

export default mutations
